import {RenewalData} from "@/store/api/renewalApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface RenewalState {
    renewalData: RenewalData[];
}

const initialState: RenewalState = {
    renewalData: []
}

const renewalSlice = createSlice({
    name: "renewals",
    initialState,
    reducers: {
        setRenewal: (state, action: PayloadAction<RenewalData[]>) => {
            state.renewalData = action.payload;
        }
    }
})


export const {setRenewal} = renewalSlice.actions;
export default renewalSlice.reducer;